var map = {
	"./at.svg": "e92a",
	"./be.svg": "06ca",
	"./de.svg": "5de7",
	"./dk.svg": "fe2d",
	"./gb-eng.svg": "a2a9",
	"./gb-wls.svg": "1b48",
	"./gb.svg": "8cb8",
	"./gg.svg": "1926",
	"./ie.svg": "a4a8",
	"./im.svg": "fb67",
	"./je.svg": "1cec1",
	"./nations/england.svg": "5869",
	"./nations/northern ireland.svg": "7a04",
	"./nations/scotland.svg": "4d02",
	"./nations/wales.svg": "8a3a",
	"./nl.svg": "9517",
	"./se.svg": "702f",
	"./sk.svg": "e903"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e03";